import PaymentDetails from './PaymentDetails';

export { default as DetailRow } from './DetailRow';
export default PaymentDetails;
